import EmailTemplates from "./components/EmailTemplates";

export default EmailTemplates;
